import { createTemporaryId } from "../utils/model";

export enum CohearingMessageFeeling {
  Confetti = 'confetti',
  Good = 'good',
  Warning = 'warning'
}


export class CohearingMessage {
  static maxTextLength = 60;// See StandardCohearingMessage.maxCount in s2-dial.

  readonly id = createTemporaryId();

  /**
   * Required unless `type` is `confetti`.
   */
  readonly text: string = "";
  readonly feeling?: CohearingMessageFeeling;

  /**
   * The parked call ID. Used for UI to know which call the message was intended for.
   */
  readonly easyTelecomUserCallId: string;

  /**
   * Whether the receiver user has sent an acknowledge message for this message.
   */
  readonly acknowledgedAt?: Date;
  readonly createdAt: Date = new Date();

  constructor(deriveFrom?: Partial<CohearingMessage>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }
}